import { useTranslation } from 'react-i18next'

import { Badge } from '@/components/ui'
import type { BadgeProps } from '@/components/ui'

/**
 * Modo de operacao do agente, SEMPRE visivel no Desk (docs/design/01 secao 11: o modo atual deve aparecer em telas
 * criticas). Sem "AI theater": e apenas um rotulo do estado real. `null` = nenhum agente ativo configurado. Enquanto
 * `loading` (estado ainda nao resolvido), NAO afirma "sem agente" — mostra um placeholder neutro (docs/design/01 s10).
 */
export function AgentModeBadge({
  mode,
  loading = false,
}: {
  readonly mode: string | null
  readonly loading?: boolean
}) {
  const { t } = useTranslation()

  const variant: BadgeProps['variant'] = loading
    ? 'neutral'
    : mode === 'AutoReply'
      ? 'warning'
      : mode === 'Suggest'
        ? 'info'
        : 'neutral'

  const label = loading
    ? t('desk.agentMode.loading')
    : mode === 'ObserveOnly'
      ? t('desk.agentMode.observeOnly')
      : mode === 'Suggest'
        ? t('desk.agentMode.suggest')
        : mode === 'AutoReply'
          ? t('desk.agentMode.autoReply')
          : t('desk.agentMode.none')

  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="text-xs text-foreground-muted">{t('desk.agentMode.label')}</span>
      <Badge variant={variant}>{label}</Badge>
    </span>
  )
}
